define(
  'load-mortgage',[
  ],
  function
  (
  ) {
    'use strict';

    const morgageElement = document.getElementById('ShowMortgageSection');
    let showMortgage = morgageElement && morgageElement.value === 'true';

    let onDomComplete = function (fn) {
      if (document.readyState !== 'complete') {
        document.addEventListener('readystatechange', function (e) {
          if (document.readyState === 'complete') {
            fn(e);
          }
        });
      } else {
        fn();
      }
    };
    return {
      init: function (elementToObserve) {
        if (!showMortgage) {
          return;
        }

        onDomComplete(function () {
          const mortgageSection = document.querySelector('[data-mortgage-section]');
          let detailsContainer = (elementToObserve && elementToObserve.parentNode) ||
          document.querySelector('[data-mortage-container]');
          let refElement = elementToObserve || document.querySelector('[data-mortage-observer]');

          if (!detailsContainer || !showMortgage) {
            return;
          }

          let intersectionObserver = new IntersectionObserver(function (entries, observer) {
            if (entries[0] && entries[0].intersectionRatio === 0) {
              return;
            }
            let zipCode = document.getElementById('ZipCode').value;
            let price = document.getElementById('Price').value;
            let width = entries[0].target.clientWidth - 20;
            let height = document.documentElement.clientHeight / 1.5;
            let iframe = document.createRange().createContextualFragment(
              "<iframe title='Mortgage Rates Table' " +
              "src='https://widgets.icanbuy.com/c/standard/us/en/mortgage/tables/Mortgage.aspx?" +
              'siteid=206f35c4e7ee1a32&amp;searchbtnbgcolor=ffce34&amp;searchbtntextcolor=2c2c2c' +
              '&amp;listingbtnbgcolor=0079d2&amp;size=' +
                        width +
                        '&amp;loan_type=PURCH&amp;zip=' +
                        zipCode +
                        '&amp;property_value=' +
                        price +
                        "' width='" +
                        width +
                        "' height='" +
                        height +
                        "' border='0' style='display:block;margin:0;border:0; width:100%;'></iframe>"
            ).querySelector('*');

            if (elementToObserve) {
              detailsContainer.insertBefore(iframe, elementToObserve);
            } else {
              detailsContainer.appendChild(iframe);
            }

            if (mortgageSection) {
              mortgageSection.removeAttribute('hidden')
            }

            observer.disconnect();
          });
          intersectionObserver.observe(refElement);
        });
      }
    };
  }
);

